var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolume = function SvgVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#52C41A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15 10v4M18 8v8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#52C41A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.875 8.625H3.5a1 1 0 0 0-1 1v4.75a1 1 0 0 0 1 1h2.375l3.979 3.37a1 1 0 0 0 1.646-.762V6.017c0-.852-.997-1.314-1.646-.763z",
    clipRule: "evenodd"
  })));
};
export { SvgVolume as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMGFkZDAxNDM1OWM1MDA3MGI1MTQ4NzcxMzZiMjdjNWQuc3ZnIjs=";